module.exports = __webpack_public_path__ + "static/media/yelpicon.124f3514.png";